import { useCallback, useState } from 'react';
import { Button, Pagination } from 'antd';
import { Plus, Shuffle } from 'lucide-react';
import { useMaasCredentials } from './hooks/useMaasCredentials';
import ModelCredentialTable from './components/ModelCredentialTable';
import CreateCredentialDialog from './components/CreateCredentialDialog';
import EditCredentialDialog from './components/EditCredentialDialog';
import TenantFailoverDialog from './components/TenantFailoverDialog';
import CredentialNameSearch from './components/CredentialNameSearch';
import { type MaasCredential } from '@/proto/agentplatform/v2/maas_pb';

export default function ModelCredentialsTab() {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [name, setName] = useState('');
  const { data, isLoading } = useMaasCredentials(page, pageSize, true, name);
  const [createOpen, setCreateOpen] = useState(false);
  const [failoverOpen, setFailoverOpen] = useState(false);
  const [editTarget, setEditTarget] = useState<MaasCredential | null>(null);

  // Failover 备用池已迁至独立 TenantFailover 表，托管凭证列表直接展示全部。
  const list = data?.items ?? [];
  const handleSearch = useCallback((value: string) => {
    setName(value);
    setPage(1);
  }, []);
  const totalCount = data?.total ?? 0;

  return (
    <>
      <div className="creds-toolbar">
        <span className="tab-desc">托管模型 API Key + 默认模型 · 创建后可被 Agent 模板引用</span>
        <div style={{ flex: 1 }} />
        <CredentialNameSearch onSearch={handleSearch} />
        <Button
          icon={<Shuffle size={14} />}
          style={{ marginRight: 8 }}
          onClick={() => setFailoverOpen(true)}
        >
          Failover 配置
        </Button>
        <Button type="primary" icon={<Plus size={14} />} onClick={() => setCreateOpen(true)}>
          新建凭证
        </Button>
      </div>

      <ModelCredentialTable data={list} loading={isLoading} onEdit={(row) => setEditTarget(row)} />

      {!isLoading && totalCount > 0 && (
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 16 }}>
          <Pagination
            current={page}
            pageSize={pageSize}
            total={totalCount}
            showSizeChanger
            pageSizeOptions={[10, 20, 50, 100]}
            showTotal={(t) => `共 ${t} 条`}
            onChange={(p, ps) => {
              setPage(p);
              setPageSize(ps);
            }}
          />
        </div>
      )}

      <CreateCredentialDialog open={createOpen} onClose={() => setCreateOpen(false)} />
      <EditCredentialDialog
        open={!!editTarget}
        credential={editTarget}
        onClose={() => setEditTarget(null)}
      />
      <TenantFailoverDialog open={failoverOpen} onClose={() => setFailoverOpen(false)} />
    </>
  );
}
